import { onMarsCommonMistakes } from './commonMistakes';
import { onMarsFaqExtended } from './faqExtended';
import { onMarsGuidedTutorial } from './guidedTutorial';
import {
  ON_MARS_CHAPTER_TITLES,
  OnMarsSectionMeta,
  errId,
  faqId,
  fgId,
  fmId,
  gtId,
  qrId,
  refId,
} from './navigationTypes';
import { onMarsReference } from './reference';

/** Curated relatedSectionIds — only meaningful topic clusters. */
const RELATED: Record<string, string[]> = {
  [fmId(7)]: [fmId(32), fmId(8), refId('ref-crystal'), faqId('faqx-004'), errId('mistake-01')],
  [fmId(8)]: [fmId(32), fmId(18), refId('ref-colonist'), faqId('faqx-005')],
  [fmId(9)]: [fmId(28), fmId(13), refId('ref-bot'), faqId('faqx-008'), errId('mistake-02')],
  [fmId(10)]: [fmId(33), refId('ref-rover'), qrId('rover')],
  [fmId(11)]: [fmId(20), fmId(22), fmId(30), refId('ref-private-ship')],
  [fmId(12)]: [fmId(25), fmId(34), fmId(13), refId('ref-technology'), qrId('technology')],
  [fmId(13)]: [fmId(28), fmId(9), fmId(12), refId('ref-complex'), qrId('buildings')],
  [fmId(14)]: [fmId(35), fmId(28), refId('ref-lss'), refId('ref-colony-level'), qrId('lss')],
  [fmId(15)]: [fmId(36), fmId(38), fmId(16), refId('ref-mission')],
  [fmId(16)]: [fmId(15), fmId(39), refId('ref-private-goal')],
  [fmId(18)]: [fmId(19), fmId(21), fmId(32), qrId('turn-order')],
  [fmId(19)]: [fmId(23), fmId(20), refId('ref-orbit'), gtId('turn-orbit-001')],
  [fmId(20)]: [fmId(19), fmId(21), fmId(11), refId('ref-shuttle'), qrId('travel')],
  [fmId(21)]: [fmId(27), fmId(22), refId('ref-mars'), gtId('turn-mars-001')],
  [fmId(22)]: [fmId(20), fmId(19), fmId(11), qrId('travel')],
  [fmId(28)]: [fmId(13), fmId(9), fmId(14), refId('ref-construction'), errId('mistake-02')],
  [fmId(31)]: [fmId(13), fmId(17), refId('ref-scientist')],
  [fmId(32)]: [fmId(7), fmId(8), fmId(18), refId('ref-executive-action'), qrId('executive-actions')],
  [fmId(35)]: [fmId(14), fmId(28), qrId('lss'), gtId('colony-update-001')],
  [fmId(38)]: [fmId(15), fmId(39), refId('ref-end-trigger'), gtId('end-trigger-001')],
  [fmId(39)]: [fmId(38), fmId(15), fmId(16), refId('ref-end-scoring')],

  [refId('ref-lss')]: [fmId(14), fmId(35), qrId('lss')],
  [refId('ref-colony-level')]: [fmId(14), fmId(35), gtId('colony-update-001')],
  [refId('ref-technology')]: [fmId(12), fmId(25), fmId(34), qrId('technology')],
  [refId('ref-complex')]: [fmId(13), fmId(28), faqId('faqx-011')],
  [refId('ref-bot')]: [fmId(9), fmId(28), faqId('faqx-008')],
  [refId('ref-crystal')]: [fmId(7), fmId(32), faqId('faqx-004')],
  [refId('ref-orbit')]: [fmId(19), fmId(23), gtId('turn-orbit-001')],
  [refId('ref-mars')]: [fmId(21), fmId(27), gtId('turn-mars-001')],
  [refId('ref-shuttle')]: [fmId(20), fmId(37), gtId('shuttle-001')],
  [refId('ref-mission')]: [fmId(15), fmId(36), fmId(38)],
  [refId('ref-construction')]: [fmId(28), fmId(9), fmId(13)],
  [refId('ref-executive-action')]: [fmId(32), faqId('faqx-002'), qrId('executive-actions')],
  [refId('ref-end-scoring')]: [fmId(39), fmId(38)],

  [faqId('faqx-001')]: [fmId(19), fmId(21), refId('ref-orbit'), refId('ref-mars')],
  [faqId('faqx-002')]: [fmId(32), refId('ref-executive-action')],
  [faqId('faqx-004')]: [fmId(7), refId('ref-crystal'), errId('mistake-01')],
  [faqId('faqx-008')]: [fmId(9), fmId(10), refId('ref-bot'), refId('ref-rover')],
  [faqId('faqx-011')]: [fmId(13), fmId(12), refId('ref-complex')],
  [faqId('faqx-012')]: [fmId(34), fmId(12), refId('ref-technology')],
  [faqId('faqx-051')]: [fmId(20), fmId(22), qrId('travel'), errId('mistake-09')],

  [qrId('lss')]: [fmId(35), fmId(14), refId('ref-lss')],
  [qrId('buildings')]: [fmId(13), fmId(28), refId('ref-complex')],
  [qrId('technology')]: [fmId(12), fmId(34), refId('ref-technology')],
  [qrId('travel')]: [fmId(20), fmId(22), refId('ref-shuttle')],
  [qrId('executive-actions')]: [fmId(32), refId('ref-executive-action')],

  [errId('mistake-01')]: [fmId(7), faqId('faqx-004'), refId('ref-crystal')],
  [errId('mistake-02')]: [fmId(9), fmId(28), refId('ref-bot')],
  [errId('mistake-03')]: [fmId(13), fmId(12), faqId('faqx-011')],
  [errId('mistake-07')]: [fmId(9), fmId(10), faqId('faqx-008')],
  [errId('mistake-09')]: [fmId(20), fmId(22), faqId('faqx-051'), qrId('travel')],

  [gtId('turn-orbit-001')]: [fmId(19), fmId(23), refId('ref-orbit')],
  [gtId('turn-mars-001')]: [fmId(21), fmId(27), refId('ref-mars')],
  [gtId('shuttle-001')]: [fmId(20), fmId(37), qrId('travel')],
  [gtId('colony-update-001')]: [fmId(14), fmId(35), refId('ref-colony-level')],
  [gtId('end-trigger-001')]: [fmId(38), fmId(39), refId('ref-end-trigger')],
};

/** FAQ → related section ids (explicit, not text-mined). */
export const onMarsFaqSeeAlso: Record<string, string[]> = {
  'faqx-001': [fmId(19), fmId(21), refId('ref-orbit')],
  'faqx-002': [fmId(32), refId('ref-executive-action')],
  'faqx-003': [fmId(32)],
  'faqx-004': [fmId(7), refId('ref-crystal')],
  'faqx-005': [fmId(8), refId('ref-colonist')],
  'faqx-008': [fmId(9), fmId(10)],
  'faqx-011': [fmId(13), fmId(12)],
  'faqx-012': [fmId(34), fmId(12)],
  'faqx-014': [fmId(13), fmId(28)],
  'faqx-050': [fmId(32), refId('ref-executive-action')],
  'faqx-051': [fmId(20), fmId(22), qrId('travel'), errId('mistake-09')],
};

/** Reference → full manual chapter section id. */
export const onMarsReferenceFullRules: Record<string, string> = {
  'ref-water': fmId(6),
  'ref-crystal': fmId(7),
  'ref-colonist': fmId(8),
  'ref-bot': fmId(9),
  'ref-rover': fmId(10),
  'ref-scientist': fmId(31),
  'ref-orbit': fmId(19),
  'ref-mars': fmId(21),
  'ref-lss': fmId(14),
  'ref-colony-level': fmId(14),
  'ref-complex': fmId(13),
  'ref-technology': fmId(12),
  'ref-project': fmId(24),
  'ref-advanced-building': fmId(29),
  'ref-contract': fmId(17),
  'ref-private-goal': fmId(16),
  'ref-mission': fmId(15),
  'ref-shuttle': fmId(20),
  'ref-private-ship': fmId(11),
  'ref-main-action': fmId(18),
  'ref-executive-action': fmId(32),
  'ref-construction': fmId(28),
  'ref-upgrade': fmId(29),
  'ref-end-trigger': fmId(38),
  'ref-end-scoring': fmId(39),
};

const QUICK_REF: { id: string; title: string; chapterIndex: number; keywords: string[] }[] = [
  { id: 'turn-order', title: 'Kolejność tury', chapterIndex: 18, keywords: ['tura', 'kolejność'] },
  { id: 'orbit-actions', title: 'Akcje na orbicie', chapterIndex: 23, keywords: ['orbita', 'akcje'] },
  { id: 'surface-actions', title: 'Akcje na powierzchni', chapterIndex: 27, keywords: ['mars', 'akcje'] },
  { id: 'executive-actions', title: 'Akcje wykonawcze', chapterIndex: 32, keywords: ['wykonawcza'] },
  { id: 'travel', title: 'Podróż', chapterIndex: 20, keywords: ['podróż', 'wahadłowiec'] },
  { id: 'buildings', title: 'Budynki i kompleksy', chapterIndex: 13, keywords: ['budowa', 'kompleks'] },
  { id: 'technology', title: 'Technologia', chapterIndex: 12, keywords: ['technologia'] },
  { id: 'rover', title: 'Łazik', chapterIndex: 33, keywords: ['łazik'] },
  { id: 'lss', title: 'LSS', chapterIndex: 35, keywords: ['lss', 'kolonia'] },
  { id: 'round-end', title: 'Koniec rundy', chapterIndex: 37, keywords: ['runda'] },
  { id: 'game-end', title: 'Koniec gry', chapterIndex: 38, keywords: ['koniec'] },
  { id: 'scoring', title: 'Punktacja', chapterIndex: 39, keywords: ['punktacja', 'op'] },
];

const FIRST_GAME_TITLES: { id: number; title: string }[] = [
  { id: 1, title: 'Wybierz długość i misje' },
  { id: 2, title: 'Rozłóż orbitę' },
  { id: 3, title: 'Rozłóż powierzchnię' },
  { id: 4, title: 'Przygotuj plansze graczy' },
  { id: 5, title: 'Wybierz kolejność i położenie wahadłowca' },
  { id: 6, title: 'Poznaj strukturę rundy' },
  { id: 7, title: 'Wykonaj pierwszą turę na orbicie' },
  { id: 8, title: 'Obsłuż pole z czerwonym kolonistą' },
  { id: 9, title: 'Wzmocnij akcję' },
  { id: 10, title: 'Rozpatrz Fazę Wahadłowca' },
  { id: 11, title: 'Podróż na powierzchnię' },
  { id: 12, title: 'Przesuń bota' },
  { id: 13, title: 'Zbuduj samotny budynek' },
  { id: 14, title: 'Zbuduj kompleks' },
  { id: 15, title: 'Przesuń LSS' },
  { id: 16, title: 'Pozyskaj i użyj planu' },
  { id: 17, title: 'Przyjmij statek' },
  { id: 18, title: 'Użyj łazika' },
  { id: 19, title: 'Zatrudnij naukowca albo weź kontrakt' },
  { id: 20, title: 'Podróż na orbitę i produkcja' },
  { id: 21, title: 'Kontroluj misje' },
  { id: 22, title: 'Zrealizuj cel prywatny' },
  { id: 23, title: 'Rozpoznaj uruchomienie końca' },
  { id: 24, title: 'Wykonaj punktację końcową' },
];

function withRelated(section: OnMarsSectionMeta): OnMarsSectionMeta {
  const related = RELATED[section.id];
  if (!related || related.length === 0) {
    return section;
  }
  const merged = [
    ...new Set([...(section.relatedSectionIds ?? []), ...related]),
  ];
  return { ...section, relatedSectionIds: merged };
}

function buildSections(): OnMarsSectionMeta[] {
  const chapters: OnMarsSectionMeta[] = ON_MARS_CHAPTER_TITLES.map(
    (title, index) =>
      withRelated({
        id: fmId(index),
        title,
        source: 'fullManual',
        screen: 'fullManual',
        targetId: String(index),
        keywords: [title.toLocaleLowerCase('pl')],
      })
  );

  const firstGame: OnMarsSectionMeta[] = FIRST_GAME_TITLES.map((step) =>
    withRelated({
      id: fgId(step.id),
      title: step.title,
      source: 'firstGame',
      screen: 'firstGame',
      targetId: String(step.id - 1),
      keywords: [step.title.toLocaleLowerCase('pl')],
    })
  );

  const quick: OnMarsSectionMeta[] = QUICK_REF.map((item) =>
    withRelated({
      id: qrId(item.id),
      title: item.title,
      source: 'quickReference',
      screen: 'quickReference',
      targetId: item.id,
      keywords: item.keywords,
      relatedSectionIds: [fmId(item.chapterIndex), ...(RELATED[qrId(item.id)] ?? [])],
    })
  );

  const faq: OnMarsSectionMeta[] = onMarsFaqExtended.map((entry) =>
    withRelated({
      id: faqId(entry.id),
      title: entry.question,
      source: 'faq',
      screen: 'onMarsFaq',
      targetId: entry.id,
      keywords: [...entry.tags, entry.question.toLocaleLowerCase('pl')],
    })
  );

  const reference: OnMarsSectionMeta[] = onMarsReference.map((entry) =>
    withRelated({
      id: refId(entry.id),
      title: entry.title,
      source: 'reference',
      screen: 'onMarsReference',
      targetId: entry.id,
      keywords: [...entry.tags, entry.title.toLocaleLowerCase('pl')],
    })
  );

  const mistakes: OnMarsSectionMeta[] = onMarsCommonMistakes.map((entry) =>
    withRelated({
      id: errId(entry.id),
      title: entry.title,
      source: 'mistakes',
      screen: 'onMarsMistakes',
      targetId: entry.id,
      keywords: [...entry.tags, entry.title.toLocaleLowerCase('pl')],
    })
  );

  const guided: OnMarsSectionMeta[] = onMarsGuidedTutorial.map((step) =>
    withRelated({
      id: gtId(step.id),
      title: step.title,
      source: 'guidedTutorial',
      screen: 'onMarsGuided',
      targetId: step.id,
      keywords: [...step.tags, step.title.toLocaleLowerCase('pl')],
    })
  );

  const scoring: OnMarsSectionMeta[] = [
    withRelated({
      id: 'scoring:tables',
      title: 'Tabele punktowania końcowego',
      source: 'scoring',
      screen: 'onMarsScoring',
      targetId: 'tables',
      keywords: [
        'punktacja',
        'kwatery',
        'technologie',
        'postęp',
        'ps',
        'op',
      ],
      relatedSectionIds: [fmId(39), qrId('scoring')],
    }),
  ];

  return [
    ...chapters,
    ...firstGame,
    ...quick,
    ...faq,
    ...reference,
    ...mistakes,
    ...guided,
    ...scoring,
  ];
}

export const onMarsSectionRegistry: OnMarsSectionMeta[] = buildSections();

export const onMarsSectionById: Record<string, OnMarsSectionMeta> =
  Object.fromEntries(onMarsSectionRegistry.map((section) => [section.id, section]));

export function getOnMarsSection(id: string): OnMarsSectionMeta | undefined {
  return onMarsSectionById[id];
}

export function getRelatedSections(sectionId: string): OnMarsSectionMeta[] {
  const section = onMarsSectionById[sectionId];
  if (!section?.relatedSectionIds) {
    return [];
  }
  return section.relatedSectionIds
    .map((id) => onMarsSectionById[id])
    .filter((item): item is OnMarsSectionMeta => Boolean(item));
}

export function getManualPrevNext(chapterIndex: number): {
  previous?: OnMarsSectionMeta;
  next?: OnMarsSectionMeta;
} {
  return {
    previous:
      chapterIndex > 0 ? onMarsSectionById[fmId(chapterIndex - 1)] : undefined,
    next:
      chapterIndex < ON_MARS_CHAPTER_TITLES.length - 1
        ? onMarsSectionById[fmId(chapterIndex + 1)]
        : undefined,
  };
}

export function getFaqSeeAlso(entryId: string): OnMarsSectionMeta[] {
  return (onMarsFaqSeeAlso[entryId] ?? [])
    .map((id) => onMarsSectionById[id])
    .filter((item): item is OnMarsSectionMeta => Boolean(item));
}

export function getReferenceFullRules(
  entryId: string
): OnMarsSectionMeta | undefined {
  const sectionId = onMarsReferenceFullRules[entryId];
  return sectionId ? onMarsSectionById[sectionId] : undefined;
}
